import 'admin-lte/dist/css/adminlte.min.css';
import { useLocalization } from '../../context/LocalizationContext';

const Footer = () => {
  const { t: localization } = useLocalization();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="main-footer">
      <div className="container">
        <div className='row'>
          <div className='col-md-12 text-center'>
            <p>{localization('footer_copyright', { year: currentYear })}</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer;